import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=2a57d293&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=js&"
export * from "./VideoList.vue?vue&type=script&lang=js&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=2a57d293&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57d293",
  null
  
)

export default component.exports